import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagementBaseUrl, userManagement } from "../endpoints";

export const voucherKarmaService = createApi({
  reducerPath: "voucherKarmaService",
  baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
  tagTypes: ["voucherKarma"],
  endpoints: (builder) => ({
    getAllVoucherKarma: builder.mutation({
      query: (body) => ({
        url: `${userManagement.voucherKarmaController.getAllVoucherKarma}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
        headers: { Authorization: `Bearer ${body.token}` },
        method: "GET",
      }),
    }),
    searchVoucherKarma: builder.mutation({
      query: (body) => ({
        url: userManagement.voucherKarmaController.searchVoucherKarma,
        method: "POST",
        headers: { Authorization: `Bearer ${body.token}` },
        body: body.payload,
      }),
    }),
    getVoucherKarmaById: builder.mutation({
      query: (body) => ({
        url: `${userManagement.voucherKarmaController.getVoucherKarmaById}/${body.id}`,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    saveVoucherKarma: builder.mutation({
      query: (body) => ({
        url: userManagement.voucherKarmaController.saveVoucherKarma,
        method: "POST",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    updateVoucherKarma: builder.mutation({
      query: (body) => ({
        url: `${userManagement.voucherKarmaController.updateVoucherKarma}/${body.id}`,
        method: "PUT",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },

      }),
    }),
    deleteVoucherKarma: builder.mutation({
      query: (body) => ({
        url: `${userManagement.voucherKarmaController.deleteVoucherKarma}/${body.id}`,
        method: "DELETE",
        headers: { Authorization: `Bearer ${body.token}` },

      }),
    }),
    findAllVoucherKarma: builder.mutation({
      query: (body) => ({
        url: userManagement.voucherKarmaController.findAllVoucherKarma,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },

      }),
    }),
    bulkUploadVoucherKarma: builder.mutation({
      query: (body) => ({
        url: userManagement.voucherKarmaController.bulkUploadVoucherKarma,
        method: "POST",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
  
    getAllPurposeCodes: builder.mutation({
      query: (body) => ({
        url: userManagement.voucherKarmaController.getAllPurposeCodes,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
  }),
});

export const {
  useGetAllVoucherKarmaMutation,
  useSearchVoucherKarmaMutation,
  useGetVoucherKarmaByIdMutation,
  useSaveVoucherKarmaMutation,
  useUpdateVoucherKarmaMutation,
  useDeleteVoucherKarmaMutation,
  useFindAllVoucherKarmaMutation,
  useBulkUploadVoucherKarmaMutation,
  useGetAllPurposeCodesMutation,
} = voucherKarmaService;
